import type { KeycloakTokenParsed } from 'keycloak-js';
import type Keycloak from 'keycloak-js';

/** Refresh the access token when it is valid for only this many more seconds. */
const MIN_TIME_UNTIL_TOKEN_EXPIRES = 30;

/** Check whether the access token is still valid on this interval. */
const CHECK_TOKEN_INTERVAL_MS = 5000;

/** Log out when the refresh token has fewer than this many seconds left. */
const MIN_REFRESH_TOKEN_VALIDITY_SECONDS = 10;

function isRefreshTokenValid(
  minValiditySeconds: number,
  token?: KeycloakTokenParsed,
): boolean {
  if (!token?.exp) {
    return false;
  }

  const now = Math.floor(Date.now() / 1000);
  const remaining = token.exp - now;

  return remaining > minValiditySeconds;
}

export function startKeycloakTokenRefresh(keycloak: Keycloak): void {
  const scheduleNextCheck = () => {
    window.setTimeout(() => {
      const refreshValid = isRefreshTokenValid(
        MIN_REFRESH_TOKEN_VALIDITY_SECONDS,
        keycloak.refreshTokenParsed,
      );

      if (!refreshValid) {
        void keycloak.logout();
        return;
      }

      void keycloak.updateToken(MIN_TIME_UNTIL_TOKEN_EXPIRES).then(
        () => {
          scheduleNextCheck();
        },
        (error: unknown) => {
          console.error('Token update failed', error);
          window.location.reload();
        },
      );
    }, CHECK_TOKEN_INTERVAL_MS);
  };

  scheduleNextCheck();
}
